
import { useAuth } from "@/hooks/useAuth";
import { useToast } from "@/hooks/use-toast";

export const useSessionValidation = () => {
  const { user, session, refreshSession, sessionError } = useAuth();
  const { toast } = useToast();

  const validateSession = async (): Promise<boolean> => {
    console.log('=== SESSION VALIDATION ===');
    console.log('User exists:', !!user);
    console.log('Session exists:', !!session);
    console.log('Session error:', sessionError);
    
    // Check if user exists
    if (!user) {
      console.log('Validation failed: No user');
      toast({
        title: "Authentication Required",
        description: "Please sign in to continue with your booking.",
        variant: "destructive",
      });
      return false;
    }

    // Check if session exists
    if (!session) {
      console.log('Validation failed: No session');
      toast({
        title: "Session Missing",
        description: "Your session has expired. Please sign in again.",
        variant: "destructive",
      });
      return false;
    }

    // Check if session is valid (not expired)
    const now = new Date().getTime();
    const expiresAt = new Date(session.expires_at! * 1000).getTime();
    const timeUntilExpiry = expiresAt - now;
    
    console.log('Session expires at:', new Date(session.expires_at! * 1000));
    console.log('Time until expiry (minutes):', Math.floor(timeUntilExpiry / (1000 * 60)));
    
    // If session expires within 5 minutes, try to refresh
    if (timeUntilExpiry < 5 * 60 * 1000) {
      console.log('Session expiring soon, attempting refresh...');
      const refreshed = await refreshSession();
      
      if (!refreshed) {
        console.log('Validation failed: Could not refresh session');
        toast({
          title: "Session Expired",
          description: "Your session has expired. Please sign in again to continue.",
          variant: "destructive",
        });
        return false;
      }
      
      console.log('Session refreshed successfully');
    }

    // Check for session errors
    if (sessionError) {
      console.log('Validation failed: Session error -', sessionError);
      toast({
        title: "Authentication Issue",
        description: `Session error: ${sessionError}. Please try signing in again.`,
        variant: "destructive",
      });
      return false;
    }

    console.log('Session validation passed');
    console.log('========================');
    return true;
  };

  return {
    validateSession,
    hasValidSession: !!user && !!session && !sessionError,
    sessionError,
  };
};
